import React from 'react'

const OpenRoles = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12c-1.1 0-2.042-.392-2.825-1.175C6.392 10.042 6 9.1 6 8s.392-2.042 1.175-2.825C7.958 4.392 8.9 4 10 4s2.042.392 2.825 1.175C13.608 5.958 14 6.9 14 8s-.392 2.042-1.175 2.825C12.042 11.608 11.1 12 10 12Zm-7 8a.965.965 0 0 1-.712-.288A.965.965 0 0 1 2 19v-1.8c0-.55.142-1.067.425-1.55.283-.483.675-.85 1.175-1.1.85-.433 1.808-.8 2.875-1.1C7.542 13.15 8.717 13 10 13h.35c.1 0 .2.017.3.05-.133.3-.246.613-.338.938A7.82 7.82 0 0 0 10.1 15c-.083.6-.108 1.104-.075 1.512.033.409.125.905.275 1.488.1.35.233.696.4 1.038.167.341.35.662.55.962H3Z"
        fill="#3249D7"
      />

      <path
        d="m14.375 17.175-.816-.816a.344.344 0 0 0-.253-.103.36.36 0 0 0-.262.113.356.356 0 0 0-.104.262c0 .107.035.194.104.263l1.068 1.069a.356.356 0 0 0 .263.103.356.356 0 0 0 .262-.104l2.128-2.128a.344.344 0 0 0 .104-.253.36.36 0 0 0-.113-.262.356.356 0 0 0-.262-.103.355.355 0 0 0-.263.103l-1.856 1.856Zm.525 3.075a3.65 3.65 0 0 1-1.463-.296 3.784 3.784 0 0 1-1.19-.8 3.786 3.786 0 0 1-.802-1.192 3.65 3.65 0 0 1-.295-1.462c0-.519.098-1.006.295-1.463.197-.456.464-.853.802-1.19a3.79 3.79 0 0 1 1.19-.802 3.655 3.655 0 0 1 1.463-.295c.519 0 1.006.098 1.462.295a3.77 3.77 0 0 1 1.191.802c.337.337.605.734.801 1.19.197.457.296.944.296 1.463a3.65 3.65 0 0 1-.296 1.462 3.784 3.784 0 0 1-.801 1.191 3.783 3.783 0 0 1-1.19.802 3.65 3.65 0 0 1-1.463.295Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default OpenRoles
